import { createSelector } from 'reselect';
import checkFeatureFlag from 'utils/featureFlags';
import { assertUnreachable } from 'utils/types';
export const makeSelectTransactionById = () => createSelector([
    (store, transactionId) => transactionId && store.transactions.transactionCache
        ? store.transactions.transactionCache[transactionId]
        : undefined,
    (store) => store.user.categories,
    (store) => store.user.customCategories,
], (transaction, categories, customCategories) => {
    if (transaction) {
        const categoryId = 'isCompact' in transaction && transaction.isCompact
            ? transaction.categoryId
            : transaction.category?.id;
        const category = categories?.find((cat) => cat.id === categoryId) ||
            customCategories?.find((cat) => cat.id === categoryId) ||
            transaction.category;
        if (!category)
            return undefined;
        return {
            ...transaction,
            category,
        };
    }
    return undefined;
});
export const selectSortedCustomCategories = createSelector((store) => store.user.customCategories, (customCategories) => customCategories.sort((a, b) => a.displayName.localeCompare(b.displayName)));
export const selectTransactionReceiptsById = (store, transactionId) => store.unpersistedTransactions.transactionsReceipts[transactionId];
export const selectFilteredUserTags = createSelector([
    (store) => store.transactions.tags,
    (_, sortMethod) => sortMethod,
], (tags, sortMethod) => {
    switch (sortMethod) {
        case 'Alphabetical':
            return [...tags].sort((a, b) => a.label.localeCompare(b.label));
        case 'Frequency':
            return [...tags].sort((a, b) => (b?.nOfTransactions || 0) - (a?.nOfTransactions || 0));
        case 'Recent':
            return [...tags].sort((a, b) => new Date(b.lastUsed).getTime() - new Date(a.lastUsed).getTime());
        default: {
            assertUnreachable(sortMethod);
            return tags;
        }
    }
});
export const selectTransactionsSchedules = (store) => store.transactions.transactionsScheduleArray;
export const selectTransactionScheduleById = createSelector([selectTransactionsSchedules, (_, id) => id], (schedules, id) => {
    const trxSchedule = schedules.find((schedule) => schedule.id === id);
    if (trxSchedule && trxSchedule.transactionIds) {
        return trxSchedule;
    }
    return null;
});
export const selectHasSuggestInstagramMerchantFeature = createSelector((store) => store.utils.featureFlags, (featureFlags) => checkFeatureFlag(featureFlags, 'suggest_instagram_merchant'));
export const selectOptimisedTransactionScreen = createSelector((store) => store.utils.featureFlags, (featureFlags) => checkFeatureFlag(featureFlags, 'optimised_transaction_screen'));
